import { SerializedStyles } from '@emotion/react';
import { classnames, ListItem } from '@terveystalo/design-system-react-components';
import React, { FC } from 'react';

type Props = {
  id: string;
  text: string;
  onClick: () => void;
  css?: SerializedStyles;
};

export const ComboboxItem: FC<Props> = ({ id, text, onClick, ...rest }) => {
  return (
    <ListItem
      id={id}
      role="option"
      onWhiteBackground={true}
      aria-selected="false" // TODO Check this (accessibility check)
      tabIndex={-1}
      onClick={() => onClick()}
      className={classnames('mb-0.5')}
      {...rest}
    >
      <span>{text}</span>
    </ListItem>
  );
};
